import Component from '../lib/component';

class WheelSize extends Component {
  constructor(props) {
    super(props);
    this.state = { ...props };

    // Track the click events
    this.clickHandler = this.clickHandler.bind(this);
    document.addEventListener('DOMContentLoaded', () => {
      const app = document.getElementById('inputs');
      app.addEventListener('click', this.clickHandler);
    });
  }

  clickHandler(event) {
    event.preventDefault();

    const {
      data: { componentName },
    } = this.state;

    // Get event target element and its parent
    const target = event.target || event.srcElement;
    if (!target) return;
    const parent = target.parentElement || target.parentNode;
    if (!parent) return;

    // Check if an action button for this component was clicked
    if (target.getAttribute('data-source') === componentName || target.parentElement.getAttribute('data-source') === componentName) {
      // Get the wheel size
      const size = target.getAttribute('data-size') || parent.getAttribute('data-size');
      // Update value prop
      this.updateValue(size);
    }
  }

  updateValue(size) {
    // Set state value prop with new value
    this.setState({ value: size });
  }

  // Define the template elements
  template(props) {
    const { componentName, value, sizes } = props;
    // Reset template
    this.temp = '';
    // Add template for each size in a loop
    sizes.forEach((size) => {
      this.temp = this.temp.concat(`
          <!-- Wheel size - input (hidden) -->
          <input type="radio" name="wheel-size" id="wheel-size-${size}" ${parseFloat(value) === size ? 'checked' : ''} />
          <!-- Wheel size - label -->
          <label class="rpc-section__wheel-size-label" for="wheel-size-${size}" data-source="${componentName}" data-size="${size}">
            <img class="rpc-section__wheel-size-icon" src="assets/images/icon-wheel.svg" />
            <span>${size}"</span>
          </label>
      `);
    });

    return this.temp;
  }
}

export default WheelSize;
